import { Component, Input, NgZone, OnChanges } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { CodaltComponent } from '../codalt.component';

@Component({
    selector: 'mat-error',
    templateUrl: './field-error.component.html',
    // Material's baseline ::before pushes block errors to a 2nd line, hidden under the next field
    styles: [':host.mat-mdc-form-field-bottom-align::before { display: none; }'],
    standalone: false,
})
export class FieldErrorComponent extends CodaltComponent implements OnChanges {
    @Input()
    public control: AbstractControl;
    public errors = [];
    @Input()
    customMessage: string;
    private messages = new Map<string, ErrorMessage>([
        ['required', new ErrorMessage('Dit veld is verplicht')],
        ['maxlength', new ErrorMessage('Voer maximaal %1 karakters in', 'requiredLength')],
        ['minlength', new ErrorMessage('Voer minimaal %1 karakters in', 'requiredLength')],
        ['max', new ErrorMessage('Het maximum is %1', 'max')],
        ['notAvailable', new ErrorMessage(null)],
        ['userDeleted', new ErrorMessage('Deze gebruiker is verwijderd')],
        ['email', new ErrorMessage('Vul een e-mailadres in')],
        ['invalidPhone', new ErrorMessage('Vul een telefoonnummer in')],
        ['matDatepickerMin', new ErrorMessage('De datum is niet in de toekomst')],
        ['matDatepickerParse', new ErrorMessage('De datum is niet in de toekomst')],
        ['urlNotValid', new ErrorMessage('De ingevoerde url is geen valide url')],
        ['urlStatusCode', new ErrorMessage('De ingevoerde url lijkt niet te werken')],
        ['pattern', new ErrorMessage('De ingevoerde waarde is niet toegestaan')],
        ['unique', new ErrorMessage('De ingevoerde waarde is niet uniek')],
    ]);

    constructor(private ngZone: NgZone) {
        super();
    }

    ngOnChanges() {
        this.parseErrors();
        if (this.control) {
            if (this.control.parent) {
                this.subscriptions.add(this.control.parent.valueChanges.subscribe(() => this.parseErrors()));
            }
            if (this.control.parent && this.control.parent.parent) {
                this.subscriptions.add(this.control.parent.parent.valueChanges.subscribe(() => this.parseErrors()));
            }
            this.subscriptions.add(this.control.statusChanges.subscribe(() => this.parseErrors()));
        }
    }

    private parseErrors() {
        this.errors = [];
        if (this.control && typeof this.control.errors !== 'undefined' && this.control.errors) {
            for (const [key, value] of Object.entries(this.control.errors)) {
                const message = this.messages.get(key);
                if (message) {
                    let error = message.message;
                    if (error) {
                        message.values.forEach(
                            (parseInVal, i) => (error = error.replace(`%${i + 1}`, value[parseInVal]))
                        );
                    } else {
                        error = value;
                    }
                    this.errors.push(error);
                } else {
                    console.warn(`Validation error message for ${key} is not defined`);
                }
            }
        }
    }
}

export class ErrorMessage {
    public values: string[];

    constructor(
        public message: string,
        ...vals: string[]
    ) {
        this.values = vals;
    }
}
